const compatModules = {};import * as Mod1 from "./discourse-markdown/waze-templates";
compatModules["discourse-markdown/waze-templates"] = Mod1;

export * as discourse__markdown$waze__templates$$__module from "./discourse-markdown/waze-templates";
export {
setup as discourse__markdown$waze__templates$$setup
} from "./discourse-markdown/waze-templates";
import * as Mod2 from "./discourse/components/waze-copy-template-button";
compatModules["discourse/components/waze-copy-template-button"] = Mod2;

export * as discourse$components$waze__copy__template__button$$__module from "./discourse/components/waze-copy-template-button";
export {
default as discourse$components$waze__copy__template__button$$default
} from "./discourse/components/waze-copy-template-button";
import * as Mod3 from "./discourse/initializers/waze-templates-intializer";
compatModules["discourse/initializers/waze-templates-intializer"] = Mod3;

export * as discourse$initializers$waze__templates__intializer$$__module from "./discourse/initializers/waze-templates-intializer";
export {
default as discourse$initializers$waze__templates__intializer$$default
} from "./discourse/initializers/waze-templates-intializer";
import * as Mod4 from "./discourse/services/waze-snackbar";
compatModules["discourse/services/waze-snackbar"] = Mod4;

export * as discourse$services$waze__snackbar$$__module from "./discourse/services/waze-snackbar";
export {
default as discourse$services$waze__snackbar$$default
} from "./discourse/services/waze-snackbar";
export default compatModules;
